import styled from 'styled-components';

const Container = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
	margin: 16px;
	justify-content: center;
`;

export default Container;
